import React from 'react';
import createReactClass from 'create-react-class';
import _ from 'underscore';
import Bus from '@nichoth/events';
import _State from '@nichoth/state';
import {v4 as uuid} from 'uuid'
import { useLocation } from 'react-router-dom'
// import WsLog from '@nichoth/wslog/client';

import history from '../../history';
import queryString from '../../utils/QueryString';
import EventsController from '../../events/EventsController';
import config from '../../config.js';
import EVENTS from './EVENTS';
import Websocket from './lib/websocket-demux';
import Store from './state';
import Actions from './actions';
import subscribe from './subscribe';
import reduxStore from '../../redux/store'

// take (api, socket, opts, match)
// connect state/update loop
// return view
function EventsRoute (api, socket, opts, match) {
    var clientID = opts.credentials.clientID;
    var bus = Bus();

    Websocket(EVENTS.ws, bus, clientID, config.scaledroneKey);

    var q = queryString.parse(window.location.search);
    const location = useLocation()
    // if the route is not to a specific view type then redirect to what is in the redux store
    if (location.pathname.split('/').filter(path => path.length).length === 1) {
        var viewType = reduxStore.getState().events.viewType
        history.replace(`/events/${viewType.key.toLowerCase()}${location.search}`)
    }
    
    var stores = Store({ query: q });

    var _stores = _State.Merge(stores);

    // if (process.env.NODE_ENV == 'development') {
    //     // var wslog = WsLog();
    //     _stores.state(function onChange (_state) {
    //         // wslog.state(_state);
    //         // console.log('%cstate', 'background: #35c298; color: #fff; padding: 0 .5rem', JSON.parse(JSON.stringify(_state)));
    //     });

    //     bus.on('*', function (ev, data) {
    //         // console.log('*log*', ev, data);
    //         // console.log('%clog', 'background: #a235c2; color: #fff; padding: 0 .5rem', ev, data);
    //         // wslog.event([ev, data]);
    //     });
    // }
    bus.on('*', (ev,data) => {
        reduxStore.dispatch({
            type: `BUS/${ev}`,
            payload: data,
            requestID: data && data.cid || uuid()
        })
    })

    var actions = Actions(bus);
    subscribe(bus, api, stores);

    //@TODO: handle all this state with redux
    // map the state to what the view is expecting
    var mapped = _State.map(function onChange (_state) {
        window.APP_STATE = _state
        var eventsReqs = _state.requests.events.resolving;
        return {
            data: {
                events: {
                    isResolving: _.some(_state.requests.events.resolving,
                        req => req.type === 'get'),
                    data: _state.events.sorted
                },
                eventAjaxState: _.reduce(eventsReqs, function (acc, v, k) {
                    if (v.req.eventID) acc[v.req.eventID] = v.req;
                    return acc;
                }, {}),
                encoders: {
                    isResolving: _state.requests.encoders.isResolving,
                    data: _state.encoders.sorted
                },
                preferences: {
                    isResolving: _state.requests.player.isResolving,
                    lastError: getErr(_state.requests.player.errors),
                    data: _state.playerPrefs.sorted
                },

                eventAnalytics: _state.eventAnalytics,

                miscAssets: {
                    isResolving: _state.requests.miscAssets.isResolving,
                    data: _state.miscAssets.sorted,
                    lastError: getErr(_state.requests.miscAssets.errors)
                },

                chat: {
                    data: _state.chat.data,
                    resolving: _state.requests.chat.resolving
                },

                transcript: {
                    data: _state.transcript.data,
                    isResolving: _state.requests.transcript.isResolving
                },
                transcriptView: _state.transcriptView,

                streamTargets: {
                    data: _state.streamTargets.data,
                    isResolving: _state.requests.streamTargets.isResolving
                },
                eventTargetDestinations: {
                    data: _state.eventTargetDestinations.data,
                    isResolving: _state.requests.eventTargetDestinations.isResolving
                },
                streamTargetView: _state.streamTargetView,

                metadata: {
                    analytics: {
                        // @TODO
                        isResolving: false,
                        data: []
                    },
                    technicians: {
                        isResolving: _state.requests.technicians.isResolving,
                        data: _state.technicians.sorted
                    },
                    locations: {
                        isResolving: _state.requests.locations.isResolving,
                        data: _state.locations.sorted
                    },
                    categories: {
                        isResolving: _state.requests.categories.isResolving,
                        nested: _state.categories.nested,
                        data: _state.categories.sorted
                    },
                    keywords: {
                        isResolving: _state.requests.keywords.isResolving,
                        data: _state.keywords.sorted
                    },
                    facebookLiveEvents: {
                        isResolving: _state.requests.facebookLive.isResolving,
                        data: _state.facebookLive.sorted
                    }
                }
            },

            error: _(_state.requests).map(function (domain) {
                return domain.errors[Object.keys(domain.errors)[0]];
            }).filter(Boolean)[0],

            message: _state.messages.data[0],

            query: _state.query,
            filters: _state.query,
            search: _state.query.search,
            pagination: {
                currentPage: _state.query.currentPage,
                totalPages: _state.query.totalPages
            },

            activeEvent: _state.view.activeEvent,
            socket: _state.socket,
            requests: _state.requests,
        };
    }, _stores);

    var mappedState = mapped.state.bind(mapped)
    function noop () {}

    // eslint-disable-next-line
    return createReactClass({
        render: function () {
            return <EventsController {...this.props}
                ga={opts.token}
                facebookAppID={opts.facebookAppID}
                clientID={opts.credentials.clientID}
                store={mappedState}
                actions={actions}
                onError={noop}
                getUppy={api.getUppy}
            />;
        }
    });
}

function getErr (obj) {
    var ks = Object.keys(obj);
    return ks.length ? obj[ks[0]] : null;
}

export default EventsRoute;
